module.exports = __webpack_public_path__ + "media/gallery/photo03-3652c643.webp";